import { Controller } from "@hotwired/stimulus"
import TomSelect from 'tom-select'

export default class extends Controller {
  static values = {
    removeButton: { type: Boolean, default: false },
    maxOptions: { type: Number, default: 50 },
    maxItems: { type: Number, default: null },
    sortField: { type: String, default: '' },
    allowEmptyOption: { type: Boolean, default: false }
  }

  connect() {
    if (this.element.classList.contains('tomselected')) {
      return
    }

    this.initializeTomSelect()
  }

  initializeTomSelect() {
    const options = {}

    if (this.removeButtonValue) {
      options.plugins = ['remove_button']
    }

    if (this.hasMaxOptionsValue) {
      options.maxOptions = this.maxOptionsValue === 0 ? null : this.maxOptionsValue
    }

    if (this.hasMaxItemsValue && this.maxItemsValue !== null) {
      options.maxItems = this.maxItemsValue
    }

    if (this.sortFieldValue) {
      options.sortField = this.sortFieldValue
    }

    if (this.allowEmptyOptionValue) {
      options.allowEmptyOption = true
    }

    this.tomSelect = new TomSelect(this.element, options)
  }

  disconnect() {
    if (this.tomSelect) {
      this.tomSelect.destroy()
    }
  }
}
